import { type SupplierListItem } from '@choco-admin/types';
import React from 'react';

import { SupplierForm } from '../SupplierForm';

interface SupplierProfileFormProps {
  supplier: SupplierListItem;
}

export const SupplierProfileForm: React.FC<SupplierProfileFormProps> = ({
  supplier,
}) => {
  return <SupplierForm mode="edit" supplier={supplier} />;
};
